"use strict";

import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const SELECTOR = "[data-story-timeline]";

function getItemCenterOffset(container, item) {
	const containerRect = container.getBoundingClientRect();
	const itemRect = item.getBoundingClientRect();

	return itemRect.top + itemRect.height / 2 - containerRect.top + container.scrollTop;
}

function initStoryTimeline(section) {
	const track = section.querySelector(".story-timeline-track");
	const list = section.querySelector(".story-timeline-list");
	const spine = section.querySelector(".story-timeline-spine");
	const progress = section.querySelector(".story-timeline-spine-progress");
	const items = section.querySelectorAll(".story-timeline-item");

	if (!track || !list || !spine || !progress || items.length === 0) {
		return;
	}

	const firstItem = items[0];
	const lastItem = items[items.length - 1];

	gsap.set(progress, {
		scaleY: 0,
		transformOrigin: "top center",
	});

	const updateSpine = () => {
		const startY = getItemCenterOffset(track, firstItem);
		const endY = getItemCenterOffset(track, lastItem);
		const height = Math.max(0, endY - startY);

		spine.style.top = `${startY}px`;
		spine.style.height = `${height}px`;
	};

	updateSpine();

	if (items.length < 2) {
		gsap.set(progress, { scaleY: 0 });
		return;
	}

	const tween = gsap.to(progress, {
		scaleY: 1,
		ease: "none",
		scrollTrigger: {
			trigger: firstItem,
			endTrigger: lastItem,
			start: "center center",
			end: "center center",
			scrub: true,
			invalidateOnRefresh: true,
			onRefresh: updateSpine,
		},
	});

	const resizeObserver = typeof ResizeObserver !== "undefined"
		? new ResizeObserver(() => {
			updateSpine();
			ScrollTrigger.refresh();
		})
		: null;

	if (resizeObserver) {
		resizeObserver.observe(track);
		items.forEach((item) => resizeObserver.observe(item));
	}

	return () => {
		if (resizeObserver) {
			resizeObserver.disconnect();
		}
		tween.scrollTrigger?.kill();
		tween.kill();
	};
}

function initStoryTimelines() {
	document.querySelectorAll(SELECTOR).forEach(initStoryTimeline);
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initStoryTimelines, { once: true });
} else {
	initStoryTimelines();
}
